import * as actions from './workOrder/actions'
import * as mutations from './workOrder/mutations'
import * as getters from './workOrder/getters'

const state = {
    list: [],
    autocomplete_list: [],
    props: []
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/workOrder.js